<template>
    <div class="go-home">
        <div class="go-home-btn">
            <button @click="goHome">{{ $t('common.goHome') }}</button>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goHome = () => {
    router.push('/')
}
</script>


<style scoped lang="scss">
.go-home {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    .go-home-btn {
        button {
            display: inline-block;
            width: 160px;
            height: 48px;
            font-size: 16px;
            color: #6c6c6c;
            line-height: 48px;
            border: 1px solid #dee2e6;
            background-color: #fff;
            cursor: pointer;
        }

    }
}

@media (max-width: 768px) {
    .go-home {
        margin-top: 30px;

        .go-home-btn button {
            width: 120px;
            height: 40px;
            font-size: 14px;
            line-height: 40px;
        }
    }
}
</style>